import { Dispatch, SetStateAction } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { FormControlLabel, Switch } from '@mui/material'

export function ArchivedPlanningsSwitch({ showArchived, setShowArchived }: { showArchived: boolean; setShowArchived: Dispatch<SetStateAction<boolean>> }) {
  useLingui()
  return (
    <FormControlLabel
      control={<Switch checked={showArchived} onChange={(e) => setShowArchived(e.target.checked)} color="primary" />}
      label={t`Show Archived Plannings`}
    />
  )
}
